import getToken from "./getToken";

const authHeaders = () => {
  return new Headers({ Authorization: `Bearer ${getToken()}` });
};

export default authHeaders;
